// @ts-nocheck
// Greif UI Kit = fill-accounting-support
import * as React from "react";

const DollarCircle: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.5 2c5.243 0 9.5 4.257 9.5 9.5S17.743 21 12.5 21 3 16.743 3 11.5 7.257 2 12.5 2m0 11.638a.48.48 0 0 1-.412-.24 1.188 1.188 0 0 0-2.056 1.19c.295.51.743.919 1.28 1.166v.496a1.188 1.188 0 0 0 2.376 0v-.496a2.85 2.85 0 0 0 1.662-2.591c0-1.409-.81-2.1-1.892-2.562-.367-.157-.77-.279-1.123-.449-.144-.069-.31-.12-.31-.314a.475.475 0 0 1 .887-.237 1.188 1.188 0 0 0 2.056-1.19 2.86 2.86 0 0 0-1.28-1.165V6.75a1.188 1.188 0 0 0-2.376 0v.496A2.85 2.85 0 0 0 9.65 9.838c0 1.408.81 2.099 1.892 2.56.367.158.77.28 1.123.45.144.069.31.12.31.314a.475.475 0 0 1-.475.475"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(DollarCircle);
